export const Metric = ({ label, value, unit, bad, testId }) => (
  <div className="p-4 border-r border-b border-white/10" data-testid={testId}>
    <div className="label">{label}</div>
    <div className={`font-display text-4xl mt-1 ${bad ? "text-[#FF3B30]" : "text-white"}`}>
      {value}
      <span className="text-xs font-mono text-neutral-500 ml-1">{unit}</span>
    </div>
  </div>
);
